import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import diacritics from 'diacritics';

export default {
  workflowController: [
    'runtimeConstant',
    '$scope',
    '$state',
    '$rootScope',
    '$filter',
    '$window',
    'authService',
    'flowService',
    '$uibModal',
    function (
      runtimeConstant,
      $scope,
      $state,
      $rootScope,
      $filter,
      $window,
      authService,
      service,
      uibModal
    ) {
      'use strict';

      function selectItem(item) {
        $scope.$parent.selectedItem =
          $scope.$parent.selectedItem === item ? null : item;
      }

      function parent_removedFilter(item) {
        return item.removed !== 1;
      }

      function parent_selectedFilter(item) {
        return item.selected === true;
      }

      function parent_filter(item) {
        if (
          $scope.filterQuery !== undefined &&
          $scope.filterQuery !== null &&
          $scope.filterQuery !== ''
        ) {
          var filter = diacritics.remove($scope.filterQuery).toLowerCase();
          var title = diacritics.remove(item.filter()).toLowerCase();

          return item.removed !== 1 && title.indexOf(filter) > -1;
        }
        return item.removed !== 1;
      }

      function loadMore() {
        switch ($state.current.name) {
          case 'flows.base.executions':
            $scope.loadExecutions();
            $scope.$parent.totalDisplayed += $scope.count;
            break;
          case 'flows.base.tasks':
            $scope.loadTasks();
            $scope.$parent.totalDisplayed += $scope.count;
            break;
        }
      }

      function list() {
        $rootScope.title = $state.current.data.title;
        $scope.itens = null;
        switch ($state.current.name) {
          case 'flows.base.executions':
            $scope.loadExecutions();
            break;
          case 'flows.base.models':
            $scope.loadModels();
            break;
          case 'flows.base.tasks':
            $scope.loadTasks();
            break;
        }
      }

      function loadModels() {
        service.listModels().then(function (models) {
          $scope.itens = models;
        });
      }

      function loadTasks() {
        if ($scope.itens === null) {
          service.listTasksMore(0, $scope.count).then(function (models) {
            $scope.itens = models;
          });
        } else {
          var lastId = Math.max(...$scope.itens.map((item) => item.id));

          service.listTasksMore(lastId, $scope.count).then(function (models) {
            angular.forEach(models, function (item) {
              $scope.itens.push(item);
            });
          });
        }
      }

      function loadExecutions() {
        if ($scope.itens === null) {
          service.listExecutionsMore(0, $scope.count).then(function (models) {
            $scope.itens = models;
          });
        } else {
          var lastId = Math.max(
            ...$scope.itens.map((item) => item.execution.Id)
          );

          service
            .listExecutionsMore(lastId, $scope.count)
            .then(function (models) {
              angular.forEach(models, function (item) {
                $scope.itens.push(item);
              });
            });
        }
      }

      function parent_canNewFlow() {
        return (
          $state.current.name === 'flows.base.models' && authService.isAdmin()
        );
      }

      function parent_newFlow() {
        $state.go('flows.designer.new');
      }

      function parent_cancelButton() {
        $scope.modalRemoveDocument.close();
      }

      function deleteModel() {
        service.delete($scope.selectedId.id).then(function () {
          $scope.modalRemoveDocument.close();
          $window.location.reload();
          $scope.selectedId = null;
        });
      }

      function parent_deleteFlow() {
        $scope.messageTitle = $filter('translate')('CONFIRM REMOVE');
        $scope.messageDescription = 'Essa operação não pode ser revertida.';
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');
        $scope.selectedId = $scope.$parent.selectedItem;

        $scope.modalRemoveDocument = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'workflowController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            service: service,
          },
        });
      }

      function parent_canDeleteFlow() {
        return (
          $state.current.name === 'flows.base.models' &&
          authService.isAdmin() &&
          $scope.$parent.selectedItem
        );
      }

      function parent_canViewFlow() {
        return (
          $state.current.name === 'flows.base.models' &&
          !authService.isAdmin() &&
          $scope.$parent.selectedItem
        );
      }

      function parent_viewFlow() {
        $scope.$parent.editFlow();
      }

      function parent_canEditFlow() {
        return $scope.$parent.canNewFlow() && $scope.$parent.selectedItem;
      }

      function parent_editFlow(item) {
        var guid = item ? item.guid : $scope.$parent.selectedItem.guid;
        $state.go('flows.designer.edit', { guid: guid });
      }

      function parent_cloneFlow() {
        if (!$scope.$parent.selectedItem) {
          swal.fire({
            title: $filter('translate')('SELECT FLOW TO CLONE'),
          });
        } else {
          $state.go('flows.designer.clone', {
            guid: $scope.$parent.selectedItem.guid,
          });
        }
      }

      function parent_canExecuteTask() {
        if ($state.current.name !== 'flows.base.tasks') {
          return false;
        }

        return $scope.$parent.selectedItem;
      }

      function parent_executeTask(item) {
        var guid = item ? item.rowGuid : $scope.$parent.selectedItem.rowGuid;
        $state.go('run.workflow', { guid: guid });
      }

      function run() {
        try {
          $rootScope.title = $state.current.data.title;
          $scope.$parent.selectedItem = null;
          $scope.itens = null;
          $scope.filterQuery = '';
          $scope.listFilters = null;
          $scope.count = 500;
          $scope.$parent.totalDisplayed = $scope.count - 1;

          $window.onbeforeunload = null;

          $scope.selectItem = logWrapper(
            selectItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.removedFilter = logWrapper(
            parent_removedFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.selectedFilter = logWrapper(
            parent_selectedFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.filter = logWrapper(
            parent_filter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadMore = logWrapper(
            loadMore,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.list = logWrapper(
            list,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadModels = logWrapper(
            loadModels,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadTasks = logWrapper(
            loadTasks,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadExecutions = logWrapper(
            loadExecutions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.canNewFlow = logWrapper(
            parent_canNewFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.newFlow = logWrapper(
            parent_newFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteModel = logWrapper(
            deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.deleteFlow = logWrapper(
            parent_deleteFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.canDeleteFlow = logWrapper(
            parent_canDeleteFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.canViewFlow = logWrapper(
            parent_canViewFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.viewFlow = logWrapper(
            parent_viewFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.canEditFlow = logWrapper(
            parent_canEditFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.editFlow = logWrapper(
            parent_editFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.cloneFlow = logWrapper(
            parent_cloneFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.canExecuteTask = logWrapper(
            parent_canExecuteTask,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.executeTask = logWrapper(
            parent_executeTask,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
